import { ProductApiPath, Product, useProductSchema } from "./useProductsList";
import { useCrudItem } from "../../../toolympus/api/useSimpleCrud";

export const useEditProduct = (id: string) => {
  const data = useCrudItem<Product>(`${ProductApiPath}/${id}`, {
    defaultValue: {
      _id: "",
      title: "",
      fields: [],
    }
  });

  const schema = useProductSchema();


  return {
    ...data,
    schema,
  };
}

